import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import "./PrivacyPolicy.css";

const PrivacyPolicy: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  // קביעת כיוון הטקסט לפי השפה
  const direction = i18n.language === 'he' ? 'rtl' : 'ltr';

  // גלילה אוטומטית לתחילת הדף כשמגיעים אליו או כשמגיעים שוב
  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [location.pathname]);

  const handleGoBack = () => {
    navigate(-1); // חוזר לדף הקודם בהיסטוריה
  };

  // פונקציה לגלילה לתחילת הדף
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // פונקציה לגלילה לדף יצירת הקשר
  const scrollToContact = () => {
    const contactElement = document.getElementById('contact');
    if (contactElement) {
      contactElement.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // הוספת event listener ללחיצה על הקישור
  React.useEffect(() => {
    const handleLinkClick = (e: Event) => {
      const target = e.target as HTMLElement;
      if (target.closest('.privacy-link')) {
        // אם לוחצים על קישור מדיניות פרטיות כשכבר בדף, גלול למעלה
        setTimeout(scrollToTop, 100);
      }
    };

    document.addEventListener('click', handleLinkClick);
    return () => document.removeEventListener('click', handleLinkClick);
  }, []);

  return (
    <div className="privacy-policy-page" dir={direction} data-language={i18n.language} lang={i18n.language}>
      <div className="privacy-policy-container">
        <h1 className="privacy-policy-title">{t('privacyPolicyTitle')}</h1>
        
        <div className="privacy-policy-content">
          <section className="privacy-section">
            <h2>{t('privacyWelcome')}</h2>
            <p>
              {t('privacyWelcomeText')}
            </p>
          </section>

          <section className="privacy-section">
            <h2>{t('privacyCollectionTitle')}</h2>
            <p>
              {t('privacyCollectionText')}
            </p>
          </section>

          <section className="privacy-section">
            <h2>{t('privacyRightsTitle')}</h2>
            <p>
              {t('privacyRightsText')}
            </p>
          </section>

          <section className="privacy-section">
            <h2>{t('privacyUsageTitle')}</h2>
            <p>
              {t('privacyUsageText')}
            </p>
          </section>

          <section className="privacy-section">
            <h2>{t('privacySecurityTitle')}</h2>
            <p>
              {t('privacySecurityText')}
            </p>
          </section>

          <section className="privacy-section-list">
            <h2>{t('privacyCookiesTitle')}</h2>
            <p className="privacy-section-list-p-up">
              {t('privacyCookiesTextUp')}
            </p>
            <ul className="privacy-list">
              <li>{t('privacyCookiesItem1')}</li>
              <li>{t('privacyCookiesItem2')}</li>
              <li>{t('privacyCookiesItem3')}</li>
              <li>{t('privacyCookiesItem4')}</li>
            </ul>
            <p className="privacy-section-list-p-down">
              {t('privacyCookiesTextDown')}
            </p>
          </section>

          <section className="privacy-section">
            <h2>{t('privacyInquiriesTitle')}</h2>
            <p>
              {t('privacyInquiriesText')}
            </p>
          </section>
        </div>

        <div className="custom-button">
          <button onClick={handleGoBack} className="custom-button">
            {t('backToPreviousPage')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
